import _ from "lodash";
import $ from "jquery";
import { Component, useCallback, useEffect, useRef, useState } from "react"
import ReactDatePicker from "react-datepicker";
import { Button, Card, Checkbox, Dropdown, DropdownItemProps, Form, FormProps, Image, Input, Modal, Search, SearchProps, SearchResultData, Segment, Table, TextArea } from "semantic-ui-react";
import { dialogControl } from "../controls/dialog-control";
import { notificationControl } from "../controls/notification-control";
import { useCurrentUser } from "../hooks/auth-hook";
import { ModalControlData, useModalControl } from "../hooks/commonHooks";
import { useFormConnect, useFormData } from "../hooks/formHooks";
import { hostUrl, restRequest } from "../http";
import { AREAS } from "../models/common_model";
import { FileContainerType, PageData } from "../models/common_model";
import { FieldConfigItem, FieldConfigs, RMATracking, RMATrackingConfig, RMATrackingStatus, SaleData } from "../models/rma_tracking_model";
import { fieldError, formatDateTime } from "../utils";
import { FilesInput } from "./commons/FilesInput";
import { Page } from "./commons/Page";
import { ProductionModelComponent } from "./commons/ProductionModelComponent";
import { JournalizationComponent } from "./commons/JournalizationComponent";

export function RMATrackingComponent(props: {}) {
    const currentUser = useCurrentUser();
    const [searchData, setSearchField] = useFormData<any>({});
    const [sort, setSort] = useState({ name: 'id', dir: 1 });
    const [reports, setSearchData, searchLoading] = useFormConnect<any, PageData<RMATracking>>({}, 'rma_tracking/search');

    const editModalControl = useModalControl<boolean>(false);
    const [currentEditId, setCurrentEditId] = useState<number>();
    const [statusAction, setStatusAction] = useState<number>(0);
    const [reloadNumber, setReloadNumber] = useState(0);

    const [config, setConfig] = useState<RMATrackingConfig>();
    const [fieldConfigs, setFieldConfigs] = useState<FieldConfigs>({} as any);

    const journalizationModalControl = useModalControl();
    const [currentJournalizationId, setCurrentJournalizationId] = useState<number>();

    useEffect(() => {
        restRequest<RMATrackingConfig>('rma_tracking/config').then(config => {
            setSearchField(null, { name: 'area', value: config.AVAILABLE_AREAS[0] })
            setConfig(config);
        });
    }, []);

    useEffect(() => {
        if (!_.isNull(searchData.area) && !_.isUndefined(searchData.area)) {
            restRequest<FieldConfigs>('rma_tracking/fieldConfigs/' + searchData.area).then(fc => {
                fc['status'] = { 'label': 'Status' } as any;
                fc['created_by_name'] = { 'label': 'Author' } as any;
                setFieldConfigs(fc);

                setSearchData(searchData);
            });
        }
    }, [searchData.area]);

    useEffect(() => {
        const sortInfo: any = {};
        if (sort.name && sort.dir) {
            sortInfo.sorted_field = sort.name;
            sortInfo.sorted_direction = sort.dir;
        } else {
            sortInfo.sorted_field = null;
            sortInfo.sorted_direction = null;
        }

        setSearchData((sd: any) => ({ ...sd, ...sortInfo }))
    }, [sort]);

    if (_.isNull(searchData.area) || _.isUndefined(searchData.area) || _.isEmpty(fieldConfigs)) {
        return <></>;
    }

    const searchLayoutFields = SearchLayoutByAreas[searchData.area - 0];
    const searchLayoutFieldGroups: string[][] = [];
    let currentGroup: string[] = [];
    for (const f of searchLayoutFields) {
        if (f == '_nl') {
            searchLayoutFieldGroups.push(currentGroup);
            currentGroup = [];
        } else {
            currentGroup.push(f);
        }
    }

    const listLayoutFields = ListLayoutByAreas[searchData.area - 0];

    return <>
        <Segment.Group>
            <Segment attached="top">
                <Form onSubmit={e => setSearchData((d: any) => ({
                                    ...searchData,
                                    refresh_number: (d.refresh_number || 0) + 1,
                                    page_number: 1,
                                }))}
                className="list-search" loading={searchLoading}>
                    <Form.Group>
                        {config && config.AVAILABLE_AREAS.length > 1 ? <Form.Field>
                            <Dropdown placeholder="Area" name="area" value={searchData['area'] || 0} onChange={setSearchField} options={config?.AVAILABLE_AREAS.map(s => ({ key: s, text: AREAS[s], value: s })) || []} search selection fluid></Dropdown>
                        </Form.Field> : ''}
                        <Form.Field inline>
                            <Input placeholder="ID" name="id" value={searchData.id || ''} onChange={setSearchField} fluid style={{ minWidth: '5rem' }} />
                        </Form.Field>
                        <Form.Field inline>
                            <Dropdown placeholder="Status" name="status" value={searchData['status'] || ''} onChange={setSearchField} options={[{ key: '-1', text: 'All' }].concat(_.keys(RMATrackingStatus).map(k => ({ key: k, value: k, text: RMATrackingStatus[k] })))} selection fluid></Dropdown>
                        </Form.Field>

                        {searchLayoutFieldGroups[0].map(name => {
                            const config = fieldConfigs[name];
                            return <SearchField key={name} name={name} config={config} searchData={searchData} onChange={setSearchField} />
                        })}
                    </Form.Group>
                    {searchLayoutFieldGroups.slice(1).map((g, i) => {
                        let submitButtons = <></>
                        if (i === searchLayoutFieldGroups.length - 2) {
                            submitButtons = <>
                                    <div style={{padding: '0.5rem 2rem 0 1rem'}}>
                                        <Checkbox label="Duplicated" name="duplicated" checked={!!searchData['duplicated']} onClick={e => setSearchField(null, {name: 'duplicated', value: !!!searchData['duplicated']})}  />
                                    </div>
                                    <div>
                                        <Button icon="search" type="submit"></Button>
                                        <Button as="a" icon="file excel outline" onClick={(e) => {
                                            e.preventDefault();
                                            window.open(hostUrl('rma_tracking/export?search=' + encodeURI(JSON.stringify(searchData))), '_blank')
                                        }}></Button>
                                    </div>
                                </>
                        }
                        return <Form.Group key={i}>
                            {g.map(name => {
                                const config = fieldConfigs[name];
                                return <SearchField key={name} name={name} config={config} searchData={searchData} onChange={setSearchField} />
                            })}

                            {submitButtons}
                        </Form.Group>
                    })}
                </Form>
            </Segment>
            <Segment attached="bottom">
                <Table striped sortable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell sorted={sort.name === 'id' ? [undefined, 'ascending', 'descending'][sort.dir] as any : undefined} onClick={() => {
                                if ('id' === sort.name) {
                                    const dir = (sort.dir + 1) % 3;
                                    setSort({ name: 'id', dir })
                                } else {
                                    setSort({ name: 'id', dir: 1 })
                                }
                            }}>ID</Table.HeaderCell>
                            {listLayoutFields.map(name => {
                                const config = fieldConfigs[name];
                                return <Table.HeaderCell key={name} sorted={sort.name === name ? [undefined, 'ascending', 'descending'][sort.dir] as any : undefined} onClick={() => {
                                    if (name === sort.name) {
                                        const dir = (sort.dir + 1) % 3;
                                        setSort({ name, dir })
                                    } else {
                                        setSort({ name, dir: 1 })
                                    }
                                }}>{config.label}</Table.HeaderCell>;
                            })}
                            <th>{currentUser.permissions.rma_tracking.receive && <Button color="blue" content="Receive Rma Tracking" size="mini" onClick={e => {
                                setCurrentEditId(undefined);
                                setStatusAction(0);
                                editModalControl.data = false;
                                editModalControl.setOpen(true);
                            }} />}</th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {reports?.items.map(tracking => {
                            return <tr key={tracking.id}>
                                <td>{tracking.id}</td>
                                {listLayoutFields.map(name => {
                                    const config = fieldConfigs[name];
                                    let text = (tracking as any)[name];
                                    if (text !== null && text !== undefined) {
                                        if (name === 'status') {
                                            text = RMATrackingStatus[text];
                                        } if (config.type == 'datetime') {
                                            text = formatDateTime(text);
                                        }
                                    }
                                    return <td key={name}>{text}</td>;
                                })}
                                <td>
                                    {/* <Button onClick={e => {
                                        setCurrentViewId(tracking.id);
                                        viewModalControl.setOpen(true);
                                    }} color="blue" icon="search" size="mini" /> */}
                                    {[0].includes(tracking.status) && currentUser.permissions.rma_tracking.receive && <Button onClick={e => {
                                        e.preventDefault();
                                        setCurrentEditId(tracking.id);
                                        setStatusAction(0);
                                        editModalControl.data = false;
                                        editModalControl.setOpen(true);
                                    }} size="mini" compact>Receive</Button>}

                                    {[0, 1].includes(tracking.status) && currentUser.permissions.rma_tracking.repair && <Button onClick={e => {
                                        e.preventDefault();
                                        setCurrentEditId(tracking.id);
                                        setStatusAction(1);
                                        editModalControl.data = false;
                                        editModalControl.setOpen(true);
                                    }} size="mini" compact>{tracking.status === 1 ? 'Edit' : 'Repaire'}</Button>}

                                    {[1, 2].includes(tracking.status) && currentUser.permissions.rma_tracking.return && <Button onClick={e => {
                                        e.preventDefault();
                                        setCurrentEditId(tracking.id);
                                        setStatusAction(2);
                                        editModalControl.data = false;
                                        editModalControl.setOpen(true);
                                    }} size="mini" compact>{tracking.status === 2 ? 'Edit' : 'Return'}</Button>}

                                    {!currentUser.permissions.rma_tracking.receive && !currentUser.permissions.rma_tracking.repair && !currentUser.permissions.rma_tracking.return && <Button onClick={e => {
                                        e.preventDefault();
                                        setCurrentEditId(tracking.id);
                                        setStatusAction(2);
                                        editModalControl.data = true;
                                        editModalControl.setOpen(true);
                                    }} size="mini" compact>View</Button>}

                                    {currentUser.permissions.rma_tracking.delete && <Button onClick={e => {
                                        dialogControl.deletionConfirm(tracking.received_express_tracking_number, argee => {
                                            if (argee) {
                                                return restRequest(`rma_tracking/${tracking.id}`, null, 'delete').then(() => {
                                                    setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
                                                })
                                            }
                                            return Promise.resolve()
                                        })
                                    }} color="red" icon="delete" size="mini" />}

                                    <Button onClick={e => {
                                        e.preventDefault();
                                        setCurrentJournalizationId(tracking.id);
                                        journalizationModalControl.setOpen(true);
                                    }} icon="history" size="mini"></Button>
                                </td>
                            </tr>
                        })}
                    </Table.Body>
                </Table>
                <Page data={reports} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>

        {!_.isNull(searchData.area) && !_.isUndefined(searchData.area) && <Editor id={currentEditId} fieldConfigs={fieldConfigs} area_id={searchData.area} statusAction={statusAction} modalControl={editModalControl} onFinish={result => {
            setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
            editModalControl.setOpen(false)
            setReloadNumber(n => n + 1);
        }} config={config}></Editor>}

        {config && currentJournalizationId && <Journalization id={currentJournalizationId} area_id={searchData.area} modelControl={journalizationModalControl} config={config}  fieldConfigs={fieldConfigs} />}
    </>
}

function Editor(props: { id?: number, fieldConfigs: FieldConfigs, area_id: number, statusAction: number, modalControl: ModalControlData<boolean>, onFinish: (data: RMATracking) => void, config?: RMATrackingConfig }) {
    const { id, config, area_id, fieldConfigs, statusAction, modalControl } = props;
    const isCreate = !id;
    const readOnly = modalControl.data;

    const [data, setField, setData] = useFormData<RMATracking>({} as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [availableModels, setAvailableModels] = useState<string[]>([]);


    useEffect(() => {
        setData({} as any);

        setInvalidError({});
        if (id) {
            setLoading(true);
            restRequest<RMATracking>('rma_tracking/' + id).then(setData).finally(() => setLoading(false))
        } else if (config) {
            setData(d => ({ ...d, area: config.AVAILABLE_AREAS[0] }));
        }
    }, [id, config]);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps, additionData?: any) => {
        event.preventDefault();

        setLoading(true);

        let url: string;
        if (isCreate) {
            url = 'rma_tracking/';
            data.area = area_id;
        } else {
            url = `rma_tracking/${id}/${statusAction}`
        }

        restRequest<RMATracking & {_is_used_warning?: (keyof RMATracking)[]}>(url, {...data, ...additionData}, isCreate ? 'post' : 'put').then(result => {
            if (isCreate) {
                if (result._is_used_warning) {
                    const messages = result._is_used_warning.map(field => `${fieldConfigs[field].label} "${data[field]}"`);
                    const messageText = messages.length == 1 ? (messages[0] + ' is') : (messages.slice(0, messages.length -1).join(', ') + ' and ' + _.last(messages) + ' are')
                    dialogControl.confirm(`${messageText} used, Do you want to continue?`, agree => {
                        if (agree) {
                            onSubmit(event, formProps, {...additionData, _force_duplicated: true});
                        }
                        return Promise.resolve();
                    });

                    return;
                }
            }
            props.onFinish(result);
            setData(result);
            setInvalidError({});
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }

    let actionName: string, buttonName: string;
    if (isCreate) {
        actionName = 'Receive';
        buttonName = 'Save';
    } else {
        if (data.status === statusAction) {
            actionName = 'Edit';
            buttonName = 'Save';
        } else {
            const statusNames = ['Receive', 'Repaired', 'Return'];
            actionName = statusNames[statusAction];
            buttonName = RMATrackingStatus[data.status] + ' -> ' + statusNames[statusAction];
        }
    }

    const layoutFields = EditorLayoutByAreas[area_id - 0];

    const layoutFieldGroups: string[][] = [];
    let currentGroup: string[] = [];
    for (const f of layoutFields) {
        if (f == '_nl') {
            layoutFieldGroups.push(currentGroup);
            currentGroup = []
        } else {
            currentGroup.push(f);
        }
    }

    return <>
        <Modal {...modalControl.props} size="large">
            <Modal.Header>{actionName} RMA Tracking </Modal.Header>
            <Modal.Content>
                <Form onSubmit={onSubmit} loading={loading}>
                    <Form.Group widths="equal">
                        <Form.Field width={2}>
                            <label>ID</label>
                            <ViewField>{data.id || ''}</ViewField>
                        </Form.Field>

                        {layoutFieldGroups[0].map(name => {
                            const config = fieldConfigs[name];
                            return <EditField area_id={area_id} key={name} name={name} config={config} value={(data as any)[name]}
                                onChange={value => setField(null, { name, value })}
                                onOthersChange={values => setData(d => ({ ...d, ...values }))}
                                error={fieldError(name, invalidError)} id={id} statusAction={statusAction} availableModels={availableModels} onLoadModelList={setAvailableModels} />
                        })}
                    </Form.Group>

                    {layoutFieldGroups.slice(1).map((layoutGroup, groupIndex) => <Form.Group key={groupIndex} widths="equal">
                        {layoutGroup.map(name => {
                            const config = fieldConfigs[name];
                            return <EditField area_id={area_id} key={name} name={name} config={config} value={(data as any)[name]}
                                onChange={value => setField(null, { name, value })}
                                onOthersChange={values => setData(d => ({ ...d, ...values }))}
                                error={fieldError(name, invalidError)} id={id} statusAction={statusAction} availableModels={availableModels} onLoadModelList={setAvailableModels} />
                        })}
                    </Form.Group>)}

                    <div>
                        {!readOnly && <Button primary>{buttonName}</Button>}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button as="a" onClick={e => props.modalControl.setOpen(false)}>Cancel</Button>
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    </>
}

function SearchField(props: { name: string, config: FieldConfigItem, searchData: any, onChange: (event: any, data: any) => void }) {
    const { name, config, searchData, onChange } = props;
    if (config.type === 'datetime') {
        return <Form.Group inline>
            <div>{config.label}:&nbsp;</div>
            <Form.Field inline style={{ paddingRight: 0 }}>
                <ReactDatePicker showTimeSelect
                    selected={searchData[name + '_start'] ? new Date(searchData[name + '_start']) : null}
                    dateFormat="yyyy-MM-d HH:mm" onChange={(d: Date) => { onChange(null, { name: name + '_start', value: d ? d.toISOString() : '' }) }}
                    timeFormat="HH:mm"></ReactDatePicker>
            </Form.Field>
            <div>&nbsp;-&nbsp;</div>
            <Form.Field inline style={{ paddingRight: 0 }}>
                <ReactDatePicker showTimeSelect
                    selected={searchData[name + '_end'] ? new Date(searchData[name + '_end']) : null}
                    dateFormat="yyyy-MM-d HH:mm" onChange={(d: Date) => { onChange(null, { name: name + '_end', value: d ? d.toISOString() : '' }) }}
                    timeFormat="HH:mm"></ReactDatePicker>
            </Form.Field>
        </Form.Group>
    } else {
        return <Form.Field inline>
            <Input placeholder={config.label} name={name} value={searchData[name] || ''} onChange={(e, d) => onChange(null, {name, value: d.value?.trim()})} />
        </Form.Field>
    }
}


function ViewField(props: { children: any }) {
    return <div className="ui input">{props.children}</div>
}

function EditField(props: { area_id: number, name: string, config: FieldConfigItem, value: any, onChange: (value: any) => void, onOthersChange: (values: any) => void, error: string, id?: number, statusAction: number, availableModels: string[], onLoadModelList: (models: string[]) => void }) {
    const { area_id, name, config, value, onChange, onOthersChange, error, id, statusAction, availableModels, onLoadModelList } = props;

    const required = config.required <= statusAction;

    if (config.type === 'datetime') {
        return <Form.Input label={config.label} required={required} error={error}>
            <ReactDatePicker showTimeSelect
                selected={value ? new Date(value) : null}
                dateFormat="yyyy-MM-d HH:mm" onChange={(d: Date) => onChange(d && d.toISOString())}
                timeFormat="HH:mm"></ReactDatePicker>
        </Form.Input>
    } else if (config.type === 'decimal') {
        return <Form.Input required={required} type="number" label={config.label} name={name} value={value || ''} onChange={(e, d) => onChange(d.value)} error={error}>
        </Form.Input>
    } else {
        if (config.options && config.options.length > 0) {
            return <Form.Input label={config.label} required={required} error={error}>
                <Dropdown name={name} multiple={config.multiple || false} value={value || (config.multiple ? [] : '')} onChange={(e, d) => {
                    let value = d.value;
                    if (config.multiple) {
                        const values = (d.value || []) as string[]
                        value = config.options.filter(v => values.includes(v))
                    }
                    onChange(value);
                }} options={config.options.map(s => ({ key: s, text: s, value: s })) || []} search selection fluid></Dropdown>
            </Form.Input>
        }

        if (name === 'model') {
            return <ModelDropdown area_id={area_id} required={required} value={value || ''} onChange={onChange} error={error} onLoadModelList={onLoadModelList}></ModelDropdown>
        } else if (name === 'received_engraving_number') {
            return <EngravingNumberDropdown area_id={area_id} required={required} value={value || ''} label={config.label} onChange={onChange} onOthersChange={onOthersChange} error={error} availableModels={availableModels}></EngravingNumberDropdown>
        } else if (['end_user_contact', 'defect_description', 'root_cause', 'remark'].includes(name)) {
            //textarea
            return <Form.Input required={required} label={config.label} error={error}>
                <TextArea name="remark" value={value || ''} onChange={(e, d) => onChange(d.value)} />
            </Form.Input>
        } else if (['root_cause_files'].includes(name)) {
            return <Form.Input required={required} label={config.label} width={3}>
                <FilesInput name={name} value={value || []} onChange={(e, d) => onChange(d.value)} containerType={FileContainerType.RMARootCause} containerId={id || 0}></FilesInput>
            </Form.Input>
        } else {
            return <Form.Input required={required} label={config.label} name={name} value={value || ''} onChange={(e, d) => onChange(_.isString(d.value) ? d.value.trim() : d.value)} error={error}>
            </Form.Input>
        }
    }
}


class EngravingNumberDropdown extends Component<{ area_id: number, value: any, label: string, onChange: (value: any) => void, onOthersChange: (values: any) => void, required: boolean, error: any, availableModels: string[] }, { loading: boolean, results: any[] }> {
    state = { loading: false, results: [] }
    searchTimeout?: any
    searchAbortController?: AbortController
    currentCancelSearch?: {cancel: boolean}

    handleResultSelect = (event: React.MouseEvent<HTMLDivElement>, data: SearchResultData) => {
        const result = data.result;
        this.props.onChange(result.engraved);
        const rawModel = result.model;
        let model: string | undefined;
        if (this.props.availableModels) {
            model = this.props.availableModels.find(m => rawModel.startsWith(m) || m.startsWith(rawModel));
        }

        if (!model) {
            model = rawModel;
        }

        this.props.onOthersChange({ spn_number: result.spn, model, received_serial_number: result.serial, customer_id: result.customer_id, ean_number: result.ean, delivery_date: result.delivery_date})
    }

    handleSearchChange = (event: React.MouseEvent<HTMLElement>, data: SearchProps) => {
        const value = data.value as string;
        this.props.onChange(value);

        if (!value || value.length < 2) {
            return this.setState({ loading: false })
        }

        clearTimeout(this.searchTimeout);
        if (this.currentCancelSearch) {
            this.currentCancelSearch.cancel = true;
            this.currentCancelSearch = undefined;
        }
        if (this.searchAbortController) {
            this.searchAbortController.abort();
            this.searchAbortController = undefined;
        }

        this.searchTimeout = setTimeout(() => {
            this.setState({ loading: true })
            this.searchAbortController = new AbortController();
            const cancelSearch = {cancel: false}
            this.currentCancelSearch = cancelSearch

            restRequest<SaleData[]>('rma_tracking/find_sale_by_engraving_number', { keyword: value }, 'post', this.searchAbortController).then(results => {
                if (cancelSearch.cancel) {
                    return;
                }
                this.setState({
                    results: results.map(r => ({
                        title: r.title || r.engraved || '',
                        description: `Model: ${r.model}, Set Serial: ${r.setserial}, Serial: ${r.serial}, SPN: ${r.spn}, Customer Id: ${r.customer_id}, EAN: ${r.ean}, Deliver Date: ${formatDateTime(r.delivery_date)}`,
                        ...r
                    }))
                })
            }).finally(() => this.setState({ loading: false }));
        }, 300)
    }

    render() {
        const { loading, results } = this.state

        return (
            <Form.Input label={this.props.label} required={this.props.required} error={this.props.error}>
                <Search
                    loading={loading}
                    onResultSelect={this.handleResultSelect}
                    onSearchChange={this.handleSearchChange}
                    results={results}
                    value={this.props.value}
                    fluid
                    className="input"
                />
            </Form.Input>
        )
    }
}

function ModelDropdown(props: { area_id: number, value: any, onChange: (value: any) => void, required: boolean, error: any, onLoadModelList: (models: string[]) => void }) {
    const { area_id, value, onChange, required, error, onLoadModelList } = props;
    const [options, setOptions] = useState<DropdownItemProps[]>();
    const [refreshModels, setRefreshModels] = useState<number>(0);
    const modelModalControl = useModalControl();

    useEffect(() => {
        if (!_.isNull(area_id) && !_.isUndefined(area_id)) {
            restRequest<DropdownItemProps[]>(`commons/production_models/${area_id}/search_for_selection`).then(options => {
                setOptions(options);
                onLoadModelList(options.filter(o=>o.value).map(o => o.value as string));
            });
        }
    }, [area_id, refreshModels, onLoadModelList]);

    return <>
        <Form.Input label={<><label style={{ display: 'inline-block', marginRight: '1rem' }}>Model</label> <Button onClick={e => modelModalControl.setOpen(true)} compact color="blue" icon="edit outline" size="mini" as="a"></Button></>} required={required} error={error}>
            <Dropdown name="model" value={value || ''} onChange={(e, d) => {
                onChange(d.value);
            }} options={options || []} search selection fluid allowAdditions></Dropdown>
        </Form.Input>

        <Modal open={modelModalControl.props.open} onClose={() => {
            modelModalControl.props.onClose();
            setRefreshModels(n => n + 1);
        }} size="large" closeIcon="close">
            <Modal.Header> Production Models </Modal.Header>
            <Modal.Content>
                <ProductionModelComponent area_id={area_id} />
            </Modal.Content>
        </Modal>
    </>
}


function Journalization(props: { config: RMATrackingConfig, area_id: number, id: number, modelControl: ModalControlData, fieldConfigs: FieldConfigs }) {
    const { area_id, modelControl, fieldConfigs } = props;

    return <Modal {...modelControl.props} size="large">
        <Modal.Header>Journalization</Modal.Header>
        <Modal.Content>
            <JournalizationComponent containerId={props.id} containerType={3} detailFields={[...EditorLayoutByAreas[area_id - 0].filter(key => key !== '_nl').map(key => {
                const fieldConfig = fieldConfigs[key]; 

                const name = fieldConfig.label;
                let formater: undefined | ((v: any) => any) = undefined;
                let isList = false;

                if (key === 'root_cause_files') {
                    isList = true;
                    formater = v => v['name'];
                } else if (key === 'root_cause_summary') {
                    isList = true;
                } else if (fieldConfig.type == 'datetime') {
                    formater = formatDateTime;
                }

                return {
                    name,
                    key,
                    formater,
                    isList
                }
            }), {key: 'status', name: 'Status', formater: v => RMATrackingStatus[v]}]} />
        </Modal.Content>
        <Modal.Actions>
            <Button as="a" onClick={e => {
                e.preventDefault();

                props.modelControl.setOpen(false);
            }}>Close</Button>
        </Modal.Actions>
    </Modal>
}


const SearchLayoutByAreas: string[][] = [
    //China
    ['model', 'rma_received_date', 'received_express_tracking_number', '_nl', 'end_user_contact', 'received_engraving_number', 'received_serial_number', 'budget_code', '_nl'],
    //USA
    ['model', 'rma_received_date', 'received_express_tracking_number', '_nl', 'end_user_contact', 'received_engraving_number', 'received_serial_number', 'budget_code', '_nl'],
    //Vienna
    ['model', 'rma_received_date', 'received_express_tracking_number', '_nl', 'end_user_contact', 'received_engraving_number', 'received_serial_number', 'budget_code', '_nl']
]


const ListLayoutByAreas: string[][] = [
    //China
    ['model', 'status', 'received_express_tracking_number', 'rma_received_date', 'shipment_date', 'received_engraving_number', 'received_serial_number', 'spn_number', 'budget_code'],
    //USA
    ['model', 'status', 'rma_received_date', 'end_user_contact', 'shipment_date', 'received_engraving_number', 'received_serial_number', 'spn_number', 'budget_code', 'created_by_name'],
    //Vienna
    ['model', 'status', 'rma_received_date', 'end_user_contact', 'shipment_date', 'received_engraving_number', 'received_serial_number', 'spn_number', 'budget_code', 'created_by_name', 'closed_date', 'remark'],
]



const EditorLayoutByAreas: string[][] = [
    //China
    ['rma_received_date', 'received_express_tracking_number', '_nl',
        'end_user_contact', '_nl',
        'shipment_date', 'received_engraving_number', 'received_serial_number', '_nl',
        'warranty', 'model', 'model_remark', '_nl',
        'spn_number', 'customer_id', 'ean_number', 'delivery_date', '_nl',
        'defect_description', '_nl',
        'root_cause', '_nl',
        'root_cause_files', '_nl',
        'liability', 'handling_method', 'root_cause_summary', 'defect_classification', '_nl',
        'ship_out_express_tracking_number', 'payment_owner', 'repair_cost', 'budget_code', '_nl',
        'return_engraving_number', 'return_serial_number', 'closed_date', '_nl',
        'remark', '_nl',
    ],
    //USA
    ['rma_received_date', 'received_express_tracking_number', '_nl',
        'end_user_contact', '_nl',
        'shipment_date', 'received_engraving_number', 'received_serial_number', '_nl',
        'warranty', 'model', 'spn_number', '_nl',
        'customer_id', 'ean_number', 'delivery_date', '_nl',
        'defect_description', '_nl',
        'root_cause', '_nl',
        'root_cause_files', '_nl',
        'liability', 'handling_method', 'root_cause_summary', 'defect_classification', '_nl',
        'ship_out_express_tracking_number', 'payment_owner', 'repair_cost', 'location_of_defective_unit', '_nl',
        'return_engraving_number', 'return_serial_number', 'closed_date', 'budget_code', '_nl',
        'remark', '_nl',
    ],
    //Vienna
    ['rma_received_date', 'received_express_tracking_number', '_nl',
        'end_user_contact', '_nl',
        'shipment_date', 'received_engraving_number', 'received_serial_number', '_nl',
        'warranty', 'model', 'spn_number', '_nl',
        'customer_id', 'ean_number', 'delivery_date', '_nl',
        'defect_description', '_nl',
        'root_cause', '_nl',
        'root_cause_files', '_nl',
        'liability', 'handling_method', 'root_cause_summary', 'defect_classification', '_nl',
        'ship_out_express_tracking_number', 'payment_owner', 'repair_cost', 'location_of_defective_unit', '_nl',
        'return_engraving_number', 'return_serial_number', 'closed_date', 'budget_code', '_nl',
        'remark', '_nl',
    ],
]